// Handlebars render method
export const Render = (template: any, data: any): void => {
	return template(data);
};
